import React from "react";
import { Reveal } from "@/components/Motion";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    sections: [
      { h: "Information We Collect", p: "We collect information you voluntarily provide through our contact and franchise enquiry forms, including your name, email, phone number, city and message details." },
      { h: "How We Use It", p: "Your information is used solely to respond to your enquiries, process franchise applications, and improve our services. We do not sell your data to third parties." },
      { h: "Data Security", p: "We take reasonable measures to protect the information you share with us. Submissions are stored securely and accessed only by authorised team members." },
      { h: "Contact", p: "For any privacy questions, reach us at koreyaah@gmail.com." },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    sections: [
      { h: "Use of Website", p: "By accessing this website you agree to use it for lawful purposes only and in a way that does not infringe the rights of others." },
      { h: "Franchise Enquiries", p: "Investment figures shown are indicative and subject to change. Final terms are confirmed after a formal evaluation and signed agreement." },
      { h: "Intellectual Property", p: "All branding, logos, imagery and content on this site are the property of Koreyaah and may not be reproduced without permission." },
      { h: "Contact", p: "For any questions about these terms, reach us at koreyaah@gmail.com." },
    ],
  },
};

export default function Legal({ type = "privacy" }) {
  const c = CONTENT[type];
  return (
    <div data-testid={`legal-${type}`} className="pt-28">
      <section className="mx-auto max-w-3xl px-5 py-16 md:py-24">
        <Reveal><p className="text-sm font-semibold uppercase tracking-[0.3em] text-koreyaah-red">Legal</p></Reveal>
        <Reveal delay={0.05}><h1 className="mt-4 font-display text-5xl md:text-6xl font-bold uppercase tracking-tight text-koreyaah-indigo">{c.title}</h1></Reveal>
        <div className="mt-12 space-y-10">
          {c.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <h2 className="font-display text-2xl font-semibold text-koreyaah-indigo">{s.h}</h2>
              <p className="mt-3 leading-relaxed text-koreyaah-indigo/75">{s.p}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
